import { useAccount } from "@/features/workspace";
import { AssessmentSurveyGroup } from "@/shared/constants/assessmentSurveys";
import { filter, groupBy, keys, set } from "lodash";
import { useSearchParams } from "react-router";

export const usePersonSurveyConfig = () => {
  const [params, setSearchParams] = useSearchParams();

  const { getAccountAssessmentSurveys } = useAccount();

  const surveyConfigs = getAccountAssessmentSurveys();

  const surveySources = keys(groupBy(surveyConfigs, "group"));

  const selectedSurveySource =
    params.get("source") || surveySources[0] || AssessmentSurveyGroup.WISNIO;

  const changeSurveySource = (source: AssessmentSurveyGroup) => {
    setSearchParams({ source });
  };

  const config = filter(
    surveyConfigs,
    (config) => config.group === selectedSurveySource
  ).map((config) => config.type);

  return {
    config: config,
    selectedSurveySource,
    changeSurveySource,
  };
};
